/**
 * Prüfungen am Terminal — dieselben Regeln wie die Toleranz-Ampel im Excel-Tagebuch
 * und die Grenzwerte der Auswertung. Die verbindliche Prüfung macht das Backend.
 */

export type Ampel = "gruen" | "gelb" | "rot" | null

/** Anfeuchtung Ist gegenüber Soll: bis ±0,9 grün, bis ±2 gelb, darüber rot. */
export function ampelAnfeuchtung(ist: number | null, soll: number | null): Ampel {
  if (ist == null || soll == null) return null
  const d = Math.abs(ist - soll)
  if (d <= 0.9) return "gruen"
  if (d <= 2) return "gelb"
  return "rot"
}

/** Grädigkeit ist ein Mindestwert: unter Soll rot, knapp am Soll gelb, ab 0,2 über Soll grün. */
export function ampelGraedigkeit(ist: number | null, soll: number | null): Ampel {
  if (ist == null || soll == null) return null
  const d = ist - soll
  if (d > 0.2) return "gruen"
  if (d >= -0.1) return "gelb"
  return "rot"
}

export const AMPEL_TEXT: Record<Exclude<Ampel, null>, string> = {
  gruen: "im Soll",
  gelb: "knapp",
  rot: "außerhalb",
}

/** "8:14", "814", "8.14" → 494 Sekunden; null, wenn unlesbar. */
export function minSek(text: string): number | null {
  const t = text.trim()
  if (!t) return null
  let m = /^(\d{1,2})\s*[:.,]\s*(\d{1,2})$/.exec(t)
  if (!m) m = /^(\d{1,2})(\d{2})$/.exec(t)
  if (!m) return null
  const sek = Number(m[2])
  if (sek > 59) return null
  return Number(m[1]) * 60 + sek
}

export function alsMinSek(sekunden: number | null | undefined): string {
  if (sekunden == null) return ""
  return `${Math.floor(sekunden / 60)}:${String(sekunden % 60).padStart(2, "0")}`
}

/** "35,6" → 35.6 */
export function zahlAus(text: string | undefined | null): number | null {
  if (text == null) return null
  const t = String(text).trim().replace(",", ".")
  if (!t) return null
  const n = Number(t)
  return Number.isFinite(n) ? n : null
}

export function alsText(v: number | string | null | undefined): string {
  if (v == null || v === "") return ""
  return String(v).replace(".", ",")
}

/** Live-Warnungen vor dem Speichern (Grenzwerte aus der Auswertung). */
export function grenzwertHinweise(
  zyklus: number | null, auswurf: number | null, fuell: number | null,
  grenzen: Record<string, [number, number]>,
): string[] {
  const h: string[] = []
  const g = grenzen
  if (zyklus != null && (zyklus < g.zykluszeit_s[0] || zyklus > g.zykluszeit_s[1])) {
    h.push(`Zykluszeit ${alsMinSek(zyklus)} min ist ungewöhnlich (5:00–20:00).`)
  }
  if (auswurf != null && (auswurf < g.auswurfgewicht_kg[0] || auswurf > g.auswurfgewicht_kg[1])) {
    h.push(`Auswurfgewicht ${alsText(auswurf)} kg ist ungewöhnlich (60–160).`)
  }
  if (fuell != null && (fuell < g.fuellgewicht_kg[0] || fuell > g.fuellgewicht_kg[1])) {
    h.push(`Füllgewicht ${alsText(fuell)} kg ist ungewöhnlich (140–230).`)
  }
  if (fuell != null && auswurf != null && auswurf > fuell) h.push("Auswurf ist größer als die Füllung.")
  return h
}
